module.exports = {
    "page.import.historyBox.processed.table.col.failure": "අසමත් වීම",
    "page.import.tab.template": "සැකිල්ල ඉතිහාසය",
    "page.im.window.units": "ඒකක",
    "page.im.setting.confirm": "මෙම කණ්ඩායමෙන් පරිශීලක ඉවත් කිරීමට ඔබට නිසැකවම තිබේද?",
    "page.import.importBox.importButton": "ගොනු උඩුගත කරන්න",
    "page.import.footer.button.another": "තවත් ආනයනය කරන්න",
    "page.import.importBox.infos.3": "කේතීකරණය ආකෘතිය: UTF-8, වෙන්කරන්න: semicolon",
    "page.im.window.draft": "කර්තෘ",
    "page.im.window.label.loading": "පැටවීම",
    "page.import.historyBox.col.action": "කටයුතු",
    "page.import.historyBox.col.status": "තත්ත්වය",
    "page.im.setting.btn.remove": "ඉවත් කරන්න",
    "page.im.window.unread": "නොකියවූ",
    "page.import.importBox.templateTitle": "ටෙම්ප්ලේට බාගැනීම",
    "page.import.historyBox.col.progress": "ප්රගතිය",
    "page.im.setting.btn.selectAll": "සියලු පිටු වලින්",
    "page.import.historyBox.search.user": "පරිශීලක",
    "page.im.setting.btn.addUser": "පරිශීලක එකතු කරන්න",
    "page.import.historyBox.col.created": "නිර්මාණය කර ඇත",
    "page.im.window.label.message": "චැට්",
    "page.im.setting.current.desc": "සියලුම පිටු තෝරා ඇත",
    "page.im.setting.tab2": "ඉක්මන් පිළිතුරු",
    "page.im.window.prdSearchPlaceholder": "කරුණාකර නිෂ්පාදන ශීර්ෂය ඇතුළු කරන්න",
    "page.im.window.label.order": "නියෝග",
    "page.im.setting.assignment.placeholder": "විද්යුත් තැපෑල, පරිශීලක නම",
    "page.import.historyBox.search.filename": "ගොනුවේ නම",
    "page.im.setting.tab1": "පරිශීලක කළමනාකරණය",
    "page.import.historyBox.search.action": "කටයුතු",
    "page.import.import": "ආනයන",
    "page.import.historyBox.col.processed": "සැකසූ",
    "page.im.window.label.orderTime": "ඇණවුම් කාලය",
    "page.im.window.process.resend": "නැවත යවන්න",
    "page.import.historyBox.processed.table.col.warning": "අවවාදයයි",
    "page.im.setting.management.title": "පාරිභෝගික සහාය",
    "page.im.window.view": "දැක්ම",
    "page.im.setting.imForm.to": "දක්වා",
    "page.im.setting.title": "කතාබස් සැකසුම්",
    "page.import.historyBox.col.filename": "ගොනුවේ නම",
    "page.import.historyBox.col.user": "පරිශීලක",
    "page.im.setting.btn.clear": "තෝරාගන්න",
    "page.im.window.label.emptyList": "ඔහ් නැත, මිලදී ගන්නන් තවමත් ඔබේ වෙළඳ සැලෙන් කිසිවක් මිලදී ගෙන නැත.",
    "page.im.setting.init.confirm": "වරක් පවරනු ලැබූ විට ප්රාථමික කෝල් ගිණුම සංස්කරණය හෝ මකා දැමිය නොහැක. ඔබ නිවැරදි ගිණුම ඉදිරිපත් කර ඇති බවට වග බලා ගන්න.",
    "page.import.importBox.importModeText": "ආයාත මාදිලිය",
    "page.import.importBox.footerTips": "Bulk Upload එකක් මගින් යාවත්කාලීන විස්තරය Lorikoet ඇතුළත නොපෙනේ. එවැනි විස්තර ලබා ගැනීම සඳහා භාණ්ඩ Excel ගොනුවේ නිෂ්පාදන බාගත කර ගන්න",
    "page.im.window.date.yesterday": "ඊයේ",
    "page.import.importBox.infos.1": "නිෂ්පාදන සෑදීමට හෝ අප්ලෝඩ් කිරීමට ඔබට CSV ගොනු (.csv) හෝ MS Excel ලේඛන (.xlsx) භාවිතා කළ හැකිය.",
    "page.import.historyBox.link.downloadErrorReport": "දෝෂ සහිත වාර්තාව බාගත කරන්න",
    "page.im.setting.imForm.from": "සිට",
    "page.import.historyBox.feedback.failed": "ඔබගේ ආයාතනය අසාර්ථකයි",
    "page.im.setting.btn.createUser": "නව පූර්ණ පිවිසුම් පරිශීලකයක් සාදන්න",
    "page.im.window.label.status": "තත්ත්වය",
    "page.import.footer.button.done": "අමාරුයි",
    "page.im.window.oversize": "උඩුගත කිරීම සඳහා ගොනුව ඉතා විශාල වේ (50M කට වඩා අඩු)",
    "page.im.window.send": "යවන්න",
    "page.import.tab.history": "ඉතිහාසය ආයාත කරන්න",
    "page.import.historyBox.link.download": "බාගත",
    "page.import.historyBox.col.type": "ගොනුවේ නම",
    "page.im.window.label.total": "මුළු",
    "page.im.window.label.refresh": "Refresh",
    "page.import.importBox.infos.2": "සටහන: Excel ගොනුවේ කිසිදු සූත්රයක් හෝ යොමු සටහන් නොමැත.",
    "page.im.setting.action": "ෂියාබායි ටෙස්ට්",
    "page.im.setting.tab3": "ස්වයං ප්රතිචාරය",
    "page.im.setting.assignment.title": "ඔබගේ ප්රාථමික චැට් ගිණුම නියම කරන්න",
    "page.im.window.orderSearchPlaceholder": "කරුණාකර ඇතුළත් කිරීමේ අංකය",
    "page.import.tab.import": "ආනයන",
    "page.im.setting.assignment.subTitle": "කරුණාකර ඔබගේ චැට් ගිණුමේ වගකීම පැවරෙන අයැදුම් කරන්න. ඔබ බහු පරිශීලකයින් සිටී නම්, ඔබගේ සියලු කථා බැලීමට හැකි එකම තැනැත්තා වනු ඇත. එය ඉදිරිපත් කළ පසු සටහන වෙනස් කළ නොහැක",
    "page.import.title": "ආනයන",
    "page.im.window.disconnection": "ජාල විසන්ධි කිරීම",
    "page.im.window.label.totalItems": "මුළු භාණ්ඩ",
    "page.im.window.label.emptyMessage": "ලැබුණු පණිවිඩයක් නොමැත.",
    "page.im.window.read": "කියවන්න",
    "page.import.historyBox.processed.table.col.sucess": "සාර්ථකත්වය",
    "page.import.historyBox.feedback.success": "ඔබගේ ආයාත කිරීම අවසන් වේ"
};